import { TranslucentMessageType } from 'components/TranslucentMessage/TranslucentMessage.component';

export type GetSelfExclusionsResponse = {
  code: string;
  message: string;
  logId: string;
  responseObject: {
    accountCode: string;
    selfExclusionList: SelfExclusionApiItem[];
  };
};

export type SelfExclusionApiItem = {
  code: string;
  accountStatus: string;
  type: string;
  period: number;
  periodUnit: string;
  startTimestamp: number;
  endTimestamp?: number | null;
  categoryCode: string;
  productCode?: string;
  productDescription?: string;
};

export type SelfExclusionCategory = {
  categoryCode: string;
  description?: string;
};

// View-model used in various UI components (ActiveExclusions, Privacy, banners)
export type ActiveExclusion = {
  code: string;
  type: SELF_EXCLUSION_TYPE;
  period: number;
  products: string[];
  startTimestamp: number;
  endTimestamp: number | null;
  cancelTimestamp: number;
};

export type SelfExclusionPostItem = {
  code: string;
  categoryCode: string;
  productCode?: string;
  period: number;
};

export type PostSelfExclusionPayload = {
  selfExclusionList: SelfExclusionPostItem[];
};

export enum SELF_EXCLUSION_COVERAGE {
  LOCAL = 'LOCAL',
  CROSS = 'CROSS',
}

export enum SELF_EXCLUSION_TYPE {
  TEMPORARY = 'TEMPORARY',
  PERMANENT = 'PERMANENT',
}

export const ProductCodesEnum = {
  SS: 'SS',
  SI: 'SI',
  IN: 'IN',
  CPS: 'CPS',
  SVC: 'SVC',
  IQF: 'IQF',
  GDC: 'GDC',
  PO: 'PO',
  CG: 'CG',
  QG: 'QG',
  BI: 'BI',
  ALL: 'ALL',
  TO: 'TO',
  VR: 'VR',
} as const;

export type ResponseMessageType = {
  show: boolean;
  type: TranslucentMessageType;
} | null;

type Extend<T, U> = T & U;

export type ResponseMessageWithExclusion = Extend<
  ResponseMessageType,
  { coverage: SELF_EXCLUSION_COVERAGE | '' }
>;
